import zIndex from "@mui/material/styles/zIndex";



export const tabelStyles = {

  tableTitleStyle: {

    backgroundColor: "#263145",

    color: "white",

    fontSize: "20px",

    textAlign: "center",

    width: "100%",

  },

  tbodyOverFlow: {

    maxHeight: "200px",

    overflowY: "scroll",

  },



  container: {

    width: "96%",

    margin: "0 auto",

  },

  tableContainer: {

    overflowX: "auto",

    maxWidth: "100%",

    maxHeight: "570px",

    overflowY: "auto",



    position: "relative",

    zIndex: "10",

  },

  table: {

    width: "100%",

    borderCollapse: "collapse",

    borderSpacing: 0,

    border: "1px solid #dee2e6",

  },

  headerRow: {

    backgroundColor: "#263145",

    color: "white",

  },

  normalHeader: {

    padding: "10px",

    minWidth: "120px",

    textAlign: "center",

    border: "1px solid #dee2e6",

    backgroundColor: "rgba(229, 229, 229, 0.54)",

  },

  expensesHeader: {

    width: "200px",

    padding: "10px",

    //   border: '1px solid #dee2e6',

  },

  headerContent: {

    display: "flex",

    alignItems: "center",

    justifyContent: "space-between",

  },

  tableCell: {

    padding: "8px",

    border: "1px solid #dee2e6",

  },

  categoryCell: {

    fontWeight: "bold",

    padding: "12px 18px",

    border: "1px solid #dee2e6",

  },

  categoryCellContent: {

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center",

  },

  valueCell: {

    textAlign: "center",

    padding: "12px 18px",

    border: "1px solid #dee2e6",

  },

  totalCell: {

    textAlign: "right",

    fontWeight: "bold",

    padding: "12px 18px",

    border: "1px solid #dee2e6",

  },

  icon: {

    fontSize: "1.2rem",

  },

  enhancedValueCell: {

    textAlign: "center",

    padding: "8px",

    border: "1px solid #dee2e6",

    minWidth: "140px",

    verticalAlign: "top",

  },

  cellContainer: {

    display: "flex",

    flexDirection: "column",

    gap: "2px",

    alignItems: "center",

    justifyContent: "center",

    minHeight: "60px",

  },

  cellRow: {

    display: "flex",

    alignItems: "center",

    justifyContent: "space-between",

    width: "100%",

    fontSize: "10px",

    padding: "1px 4px",

    borderRadius: "2px",

  },

  cellLabel: {

    fontWeight: "600",

    color: "#6c757d",

    fontSize: "9px",

    textTransform: "uppercase",

    letterSpacing: "0.5px",

  },

  cellValue: {

    fontWeight: "500",

    fontSize: "10px",

    textAlign: "right",

  },

  actualRow: {

    backgroundColor: "#f8f9fa",

  },

  forecastRow: {

    backgroundColor: "#e9ecef",

  },

  varianceRow: {

    backgroundColor: "#fff3cd",

    border: "1px solid #ffeaa7",

  },

  positiveVariance: {

    color: "#dc3545",

    fontWeight: "600",

  },

  negativeVariance: {

    color: "#28a745",

    fontWeight: "600",

  },

  neutralVariance: {

    color: "#6c757d",

  },

  cellHeader: {

    fontSize: "8px",

    fontWeight: "700",

    textTransform: "uppercase",

    color: "#495057",

    marginBottom: "4px",

    textAlign: "center",

    letterSpacing: "0.5px",

  },

  compactCell: {

    padding: "4px",

    minWidth: "120px",

  },

  compactCellContainer: {

    display: "flex",

    flexDirection: "column",

    gap: "1px",

    fontSize: "9px",

  },

  compactCellRow: {

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center",

    padding: "1px 2px",

  },

};



export const TopTabStyle = {

  display: "flex",

  justifyContent: "end",

  marginBottom: "30%",

};

export const tabStyle = {

  // width: '15%',

  background: "rgb(219, 233, 255)",

  cursor: "pointer",

  color: "#000",

  padding: "8px 12px",

  boxShadow: "inset -3px -3px 10px -7px #000",

  borderTopLeftRadius: "6px",

  borderBottomLeftRadius: "6px",

};

export const activeTabStyle = {

  // width: '15%',

  cursor: "pointer",

  padding: "8px 15px",

  fontSize: "18px",

  background: "#006c67",

  color: "#fff",

  borderRadius: "6px",

};

export const h5Style = {

  textAlign: "center",

  fontSize: "17px",

  margin: "5px 0px",

  writingMode: "vertical-lr",

  transform: "rotate(180deg)",

};



export const headerStyle = {

  headerContainer: {

    backgroundColor: "#263145",

    color: "white",

  },

};



export const budgetPlanningTrackerStyle = {

  budgetPlanningTab: {

    background: "radial-gradient(circle at center, #3d4e6d 0%, #263145 100%)",

  },

};



export const transactionPopupStyle = {

  label: {

    display: "block",

    marginBottom: "0.5rem",

    color: "#333",

    fontSize: "1.2rem",

    fontWeight: "500",

  },

  dropdownSelect: {

    width: "100%",

    padding: "0.75rem",

    border: "1.5px solid #ddd",

    borderRadius: "6px",

    fontSize: "1.1rem",

    backgroundColor: "white",

    color: "#333",

    outline: "none",

    transition: "border-color 0.2s ease",

  },

};



export const planningTabsStyle = {

  container: {

    width: "98%",

    margin: "auto",

    padding: "40px 20px",

    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",



    display: "flex",

    justifyContent: "center",

  },



  tabsWrapper: {

    width: "260px",

    borderRadius: "25px",

    padding: "6px",

    background: "linear-gradient(145deg, rgb(0, 128, 122), rgb(0, 77, 73))",

    position: "relative",

    overflow: "hidden",

  },



  tabsContainer: {

    display: "flex",

    position: "relative",

    zIndex: 2,

  },



  tab: {

    flex: 1,

    padding: "12px 10px",

    textAlign: "center",

    cursor: "pointer",

    borderRadius: "18px",

    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",

    position: "relative",

    overflow: "hidden",

    margin: "0 2px",

    userSelect: "none",

  },



  tabActive: {

    backgroundColor: "white",

    color: "#006580",

    transform: "translateY(-1px)",

    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.15)",

  },



  tabInactive: {

    backgroundColor: "transparent",

    color: "white",

    transform: "translateY(0px)",

    border: "none",

    borderRadius: "0",

  },



  tabContent: {

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    gap: "6px",

    position: "relative",

    zIndex: 1,

  },



  tabIcon: {

    fontSize: "16px",

    transition: "transform 0.3s ease",

  },



  tabText: {

    fontWeight: "bold",

    fontSize: "14px",

    letterSpacing: "0.5px",

    transition: "all 0.3s ease",

  },



  shimmer: {

    position: "absolute",

    top: "0",

    left: "-100%",

    width: "100%",

    height: "100%",

    background:

      "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)",

    transition: "left 0.5s ease",

  },



  backgroundGlow: {

    position: "absolute",

    top: "50%",

    left: "50%",

    width: "200%",

    height: "200%",

    background:

      "radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)",

    transform: "translate(-50%, -50%)",

    opacity: 0,

    transition: "opacity 0.3s ease",

    pointerEvents: "none",

  },

};

export const annualViewTabs = {

  container: {

    backgroundColor: "#ffffff",

    padding: "10px 90px",

    fontFamily: "Arial, sans-serif",

  },

  tabContainer: {

    margin: "0",

    backgroundColor: "#ffffff",

    borderRadius: "20px",

    overflow: "hidden",

    width: "100%",

  },

  tabHeader: {

    display: "flex",

    flexDirection: "column",

    borderRadius: "16px",

    // margin: "20px",

    margin: "20px 90px 20px auto",

    padding: "6px",

    backgroundColor: "radial-gradient(circle, rgb(63, 81, 120) 0%, rgb(31, 42, 61) 100%)",

    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",

    width: "400px",

  },

  tabButtonContainer: {

    display: "flex",

    justifyContent: "flex-end",

    alignItems: "center",

    width: "100%",

    gap: "10px",

  },

  tabButton: {

    flex: 1,

    padding: "14px 24px",

    backgroundColor: "transparent",

    border: "none",

    borderRadius: "12px",

    cursor: "pointer",

    fontSize: "14px",

    fontWeight: "600",

    transition: "all 0.3s ease",

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    gap: "8px",

  },

  activeTab: {

    color: "#006580",

    transform: "translateY(-1px)",

    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.15)",

    background: "radial-gradient(circle, rgb(63, 81, 120) 0%, rgb(31, 42, 61) 100%)",

    color: "#ffffff",

  },

  inactiveTab: {

    color: "#000000",

    background: "white",

    fontWeight: "500",

  },

  contentContainer: {

    // minHeight: '400px',

    maxHeight: "67vh",

    overflowY: "auto",

    overflowX: "hidden",

  },

  content: {

    width: "200%",

    display: "flex",

    flexDirection: "row",

    transition: "none",

    alignItems: "flex-start",

  },

  panel: {

    width: "50%",

    padding: "40px",

    display: "flex",

    flexDirection: "column",

    alignItems: "flex-start",

    justifyContent: "flex-start",

    minHeight: "auto",

  },

  panelIcon: {

    fontSize: "48px",

    marginBottom: "24px",

    color: "#2563eb",

  },

  panelTitle: {

    fontSize: "28px",

    fontWeight: "700",

    color: "#1f2937",

    marginBottom: "16px",

  },

  panelDescription: {

    fontSize: "16px",

    color: "#6b7280",

    textAlign: "center",

    lineHeight: "1.6",

    maxWidth: "300px",

  },

  slideIndicator: {

    bottom: "20px",

    left: "50%",

    transform: "translateX(-50%)",

    display: "flex",

    gap: "12px",

    alignItems: "center",

    color: "#9ca3af",

    fontSize: "14px",

  },

  arrow: {

    fontSize: "16px",

    cursor: "pointer",

    padding: "8px",

    borderRadius: "50%",

    transition: "all 0.3s ease",

    backgroundColor: "#f3f4f6",

    width: "32px",

    height: "32px",

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

  },

  arrowActive: {

    backgroundColor: "#2563eb",

    color: "#ffffff",

    transform: "scale(1.1)",

  },

  arrowDisabled: {

    opacity: "0.3",

    cursor: "not-allowed",

  },

};

